import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerRightDown"><Path fillRule="evenodd" clipRule="evenodd" d="M4 5H14V17.5858L11 14.5858L9.58579 16L15 21.4142L20.4142 16L19 14.5858L16 17.5858V3H4V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerRightDown;
